import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface ICreateAppVersionForm  {
  platform?: number;
  versionTag?: string;
  policyType: number;
}

export const schema = yup.object().shape({
  platform: yup
    .number()
    .oneOf([1, 2], 'Please select a platform')
    .required('Platform is required'),
  versionTag: yup
    .string()
    .required('Version is required')
    .matches(/^\d+(?:\.\d+){0,2}$/, 'Invalid version format'),
  policyType: yup
    .number()
    .required('Type is required')
    .oneOf([1, 2, 3], 'Only "Optional" (1) is currently supported'),
});

export default yupResolver(schema);
